import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Box,
  Stack,
} from "@mui/material";

const textColor = "#0d2561";
const itextColor = "#707070";

const deals = [
  { id: 1, name: "Main Street Retail", progress: 75, status: "green" },
  { id: 2, name: "Downtown Office Tower", progress: 40, status: "yellow" },
  { id: 3, name: "Suburban Apartments", progress: 90, status: "green" },
  { id: 4, name: "Industrial Park Phase 2", progress: 15, status: "red" },
];

const getProgressColor = (status: string) => {
  switch (status) {
    case "green":
      return "#22c55e"; // Tailwind green-500
    case "yellow":
      return "#eab308"; // Tailwind yellow-500
    case "red":
      return "#ef4444"; // Tailwind red-500
    default:
      return "#3b82f6"; // Tailwind blue-500
  }
};

export function DealsProgressWidget() {
  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
          Deals Progress Bar
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          List of all the deals and their progress.
        </Typography>

        <Table size="small">
          <TableBody>
            {deals.map((deal) => (
              <TableRow key={deal.id}>
                <TableCell sx={{ py: 1.5, fontWeight: 500, color: textColor }}>
                  {deal.name}
                </TableCell>
                <TableCell sx={{ py: 1.5 }} align="right">
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        position: "relative",
                        height: 16,
                        width: "60%",
                        backgroundColor: "#f3f4f6", // Tailwind bg-secondary
                        borderRadius: 999,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          height: "100%",
                          width: `${deal.progress}%`,
                          backgroundColor: textColor,
                          transition: "width 0.4s ease",
                        }}
                      />
                    </Box>
                    <Typography variant="body2" sx={{ color: itextColor }}>
                      {deal.progress}%
                    </Typography>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
